import Trinity from '@core/scripts/components/trinity-adapter';
import Device from '@core/scripts/components/device';

/*
pageViewId and wkorbId are set
 */
class TrinityHelper {
  static sendClickPdpBasic(clickName: string) {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'CLICK_PDP_BASIC'
      },
      attributes: {
        clickName: clickName,
        isApp: Device.isApp(),
        page: 'pdp',
        object: 'button'
      }
    });
  }

  // product stats
  static sendViewPpdEcInfos(digiStyleId: number, amount: string, viewName: 'likes' | 'views') {
    Trinity.sendTrinityEvent({
      schema: {
        version: 5,
        name: 'VIEW_PDP_EC_INFOS'
      },
      attributes: {
        digistyleId: digiStyleId,
        value: amount,
        viewName: viewName,
        isApp: Device.isApp(),
        page: 'pdp',
      }
    });
  }

  static sendViewCarouselUgc(numberOfPicture: number) {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'VIEW_CAROUSEL_UGC'
      },
      attributes: {
        viewName: 'ugc_carousel',
        page: 'pdp',
        isApp: Device.isApp(),
        numberOfPicture: numberOfPicture,
      }
    });
  }

  static sendClickCarouselUgc() {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'CLICK_CAROUSEL_UGC'
      },
      attributes: {
        carouselName: 'ugc_carousel',
        object: 'link',
        page: 'pdp',
        isApp: Device.isApp(),
      }
    });
  }

  static sendClickLayerUgc(articleNumber: number) {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'CLICK_LAYER_UGC'
      },
      attributes: {
        articleNumber: articleNumber,
        clickName: 'to_product',
        functionId: 21,
        object: 'link',
        page: 'pdp',
        isApp: Device.isApp(),
      }
    });
  }

  static sendViewLabelVerypopular() {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'VIEW_LABEL_VERYPOPULAR'
      },
      attributes: {
        viewName: 'veryPopular',
        page: 'pdp',
        isApp: Device.isApp(),
      }
    });
  }

  static sendViewLabelNearlySoldOut(digistyleItemOptionId: number) {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: "VIEW_LABEL_NEARLYSOLDOUT"
      },
      attributes: {
        isApp: Device.isApp(),
        page: "pdp",
        digistyleItemOptionId: digistyleItemOptionId
      }
    });
  }

  static sendViewSizeAdvice(digistyleItemOptionId: number) {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'VIEW_PDP_SIZE_ADVICE'
      },
      attributes: {
        viewName: 'sizeAdvice',
        digistyleItemOptionId: digistyleItemOptionId,
        page: 'pdp',
        isApp: Device.isApp(),
      }
    });
  }

  static sendClickSizeAdvice(open: boolean) {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'CLICK_PDP_SIZE_ADVICE'
      },
      attributes: {
        clickName: open ? 'sizeAdviceInfo' : 'sizeAdviceInfoClose',
        object: 'button',
        page: 'pdp',
        isApp: Device.isApp(),
      }
    });
  }

  static sendLayerViewSizeAdvice() {
    Trinity.sendTrinityEvent({
      schema: {
        version: 1,
        name: 'LAYERVIEW_PDP_SIZE_ADVICE'
      },
      attributes: {
        layerViewName: 'sizeAdviceInfo',
        page: 'pdp',
        isApp: Device.isApp(),
      }
    });
  }
}

export default TrinityHelper;